import { render } from "./Foot.vue?vue&type=template&id=147cb9b4&scoped=true&ts=true"
import script from "./Foot.vue?vue&type=script&lang=ts"
export * from "./Foot.vue?vue&type=script&lang=ts"

import "./Foot.vue?vue&type=style&index=0&id=147cb9b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147cb9b4"]])

export default __exports__